import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-variant-selection-dialog',
  templateUrl: './variant-selection-dialog.component.html',
  styleUrls: ['./variant-selection-dialog.component.scss'],
})
export class VariantSelectionDialogComponent implements OnInit {
  data: any = {};

  constructor(
    public dialogRef: MatDialogRef<VariantSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
  ) {
    this.dialogData = JSON.stringify(this.dialogData);
    this.dialogData = JSON.parse(this.dialogData);
    this.data = this.dialogData.dialog_data;
  }

  ngOnInit(): void {}

  onClose(): void {
    this.dialogRef.close();
  }

  onSelectVariant(value: any) {
    if (value) {
      this.dialogRef.close(value);
    } else {
      this.dialogRef.close(false);
    }
  }
}
